// Imports
var ___HTML_LOADER_IMPORT_0___ = require("assets/logo.png");
// Module
var code = `<footer id="footer" class="py-3">
  <div class="container-lg" ng-switch on="\$ctrl.page.footer">
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-xlg-8 text-center">
        <div class="row justify-content-center" ng-switch-when="views/common/footer.html|views/common/footer-no-link.html" ng-switch-when-separator="|">
          <div class="col-12 col-md-10 col-xlg-8 text-center">
            <p class="mb-0 text-dark">Copyright &COPY; {{\$ctrl.year}} | Margaret M. Lynch | All Rights Reserved.</p>
          </div>
        </div>
        <div class="row justify-content-center align-items-center" ng-switch-default>
          <div class="col-12 col-md-4 text-center text-md-start">
            <a href="https://margaretlynchraniere.com" class="foot-logo mb-3" target="_blank">
              <img ng-src="${___HTML_LOADER_IMPORT_0___}" alt="MLR" width="94" height="40" loading="lazy" decoding="async" fetchpriority="low">
            </a>
          </div>
          <div class="col-12 col-md-8 text-center text-md-end mt-3 mt-md-0">
            <p class="mb-0 text-dark">Copyright &COPY; {{\$ctrl.year}} | Margaret M. Lynch | All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>-->
  </div>
</footer>
<div id="redirectmodal" class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="redirectModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content bg-danger" ng-if="\$ctrl.isRedirecting">
      <a href="{{\$ctrl.redirectLink}}" target="_self" class="py-1 px-2 btn-close position-absolute top-0 start-100 translate-middle btn btn-light mt-0" aria-label="Close">x</a>
      <div class="modal-body align-content-center">
        <h2 class="text-white text-center mb-3" ng-bind-html="\$ctrl.page.options.redirect.title"></h2>
        <p class="text-white text-center" ng-bind-html="\$ctrl.page.options.redirect.desc"></p>
        <hsform formtarget="#formwaitlist" form="{{\$ctrl.form}}" ng-if="\$ctrl.form"></hsform>
        <div id="count" class="h1 text-center text-warning mt-4" ng-bind="\$ctrl.countdown"></div>
        <p class="mb-0 mt-3" ng-if="\$ctrl.form">Page redirecting in {{\$ctrl.counter}} seconds.</p>
      </div>
    </div>
  </div>
</div>`;
// Exports
module.exports = code;